import React from 'react';
import logo from './logo.svg';
import Routes from './routes';
import { Router } from "react-router-dom";
import { history } from "./shared";
import './App.css';
import Weblayout from './website'
import 'bootstrap/dist/css/bootstrap.min.css';
function App() 
{
  return (
    <Router history={history}>
      <Weblayout className='appweblaout'>
        <Routes/>
      </Weblayout>
    </Router>
  );
}

export default App;
